import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import CtaSection from "@/components/CtaSection";
import { AUDIENCES } from "@/data/site";

export default function WhoWeHelp() {
    return (
        <div>
            <Seo
                title="Who We Help | The Sens Civil Works Consultancy — Gorakhpur"
                description="Independent civil consultancy for homeowners, property owners, architects, small developers, housing societies and institutions in Gorakhpur, UP."
            />
            <PageHero
                overline="Who We Help"
                title="Independent Expertise for Every Kind of Client"
                description="Homeowners, property owners, architects, small developers, housing societies and institutions — anyone who needs technical clarity before a construction decision."
            />
            <section className="bg-white py-20 lg:py-28" data-testid="audiences-grid">
                <div className="mx-auto grid max-w-7xl grid-cols-1 gap-6 px-6 md:grid-cols-2 lg:px-12">
                    {AUDIENCES.map((a, i) => (
                        <Reveal key={a.title} delay={i * 0.08} className="h-full">
                            <div
                                className="group h-full border border-slate-200 bg-background p-10 transition-colors duration-300 hover:border-navy"
                                data-testid={`audience-section-${a.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            >
                                <div className="flex h-14 w-14 items-center justify-center border border-slate-200 bg-white text-navy transition-colors duration-300 group-hover:border-amber group-hover:text-amber">
                                    <a.icon size={26} strokeWidth={1.5} />
                                </div>
                                <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-amber">
                                    {String(i + 1).padStart(2, "0")}
                                </p>
                                <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-navy">
                                    {a.title}
                                </h2>
                                <p className="mt-4 text-base leading-relaxed text-slate-600">{a.description}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </section>
            <CtaSection
                overline="Your Situation"
                title="Tell Us What You're Facing"
                description="Every engagement starts with understanding your specific situation — then recommending the right scope of review."
            />
        </div>
    );
}
